import React from 'react'
import "./Home3.css"

import image_eduzolve_pasco         from "../../assets/home/_image_3.avif"
import image_eduzolve_referral      from "../../assets/home/_image_4.avif"
import image_luovien                from "../../assets/home/_image_5.avif"
import image_gifty_peter_foundation from "../../assets/home/_image_6.avif"

import { FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';



import Title from '../_title/Title'

export const appAndProjectDatabase1 = [
  {
      id: 1,
      link: "https://pubs.acs.org/doi/full/10.1021/acsomega.8b01878",
      image: image_eduzolve_pasco,
      title: "EduZove Pasco",
      abstract: "EduZolve Pasco is a cutting-edge educational app designed to help high school students in West Africa excel in their WAEC exams. It provides instant solutions, performance assessments, and a vast collection of past questions with answers. With flexible practice options, students can study anytime, anywhere, building confidence and mastering key concepts for exam success.",
  },
  {
      id: 2,
      link: "https://www.sciencedirect.com/science/article/abs/pii/S003960282030248X#fig0012",
      image: image_eduzolve_referral,
      title: "Offline Virtual Science Laboratory",
      abstract: "The Offline Virtual Science Laboratory (OVSL-Lab) is a preloaded computer-based science lab designed to let students practice physics, chemistry, biology, coding, mathematics, and computational thinking without internet access. OVSL-Lab provides a safe, accessible, and cost-effective way for students to gain hands-on scientific skills, serving both as a substitute where physical labs are lacking and as a supplementary tool for well-equipped schools.",
  },
    {
      id: 3,
      link: "https://pubs.acs.org/doi/full/10.1021/acsomega.8b01878",
      image: image_luovien,
      title: "Coding, AI & Digital Skills Program",
      abstract: "Luovien is a personal app I created to help me practice and expand my Finnish vocabulary. A few months ago, I made the decision to enhance my Finnish language skills, which inspired me to develop Luovien—a straightforward app designed for practicing Finnish words. Luovien is now available for download on both the Google Play Store and the App Store",
  },
  {
      id: 4,
      link: "https://www.sciencedirect.com/science/article/abs/pii/S003960282030248X#fig0012",
      image: image_gifty_peter_foundation,
      title: "EDvance HUB",
      abstract: "EduZolve EDvance HUB Events is a series of open sessions featuring top professionals from various fields. Through these events, speakers share their expertise to support students and young professionals with career development and life guidance",
  },
];



const Home3 = () => {
  return (
    <div className="home-3-main-container-1">
      <div className="home-3-sub-container-2">
          <Title title="OUR VISION:"/>
          <Title title="Empowering African Students for the Future"/>
        <div className='home-3-sub-container-3'>
          <h2>
            At EduZolve, we believe that Africa can be a global leader in education, technology, and innovation — but we must start by empowering every child with the tools, guidance, and opportunities to succeed. We aim to bridge the gap between access and excellence through both online and offline platforms that serve every region and income level.
          </h2>
        </div>

        <div className='home-3-sub-container-4'>
 

            {appAndProjectDatabase1.map((program, index) => (
              <Home3DisplayData key={program.id} program={program} index={index} />
            ))}
        </div>

    </div>
    </div>
  )
}


const Home3DisplayData = ({ program, index }) => {
  const backgroundClass =
    index === 0 || index === 3 ? "bg-style-1"   
      : "bg-style-2"; 

  return (
    <div className={`home-3-display-container-5 ${backgroundClass}`}>
      <img src={program.image} alt="" />
      <div className="home-3-display-container-6">
        <h4>{program.title}</h4>
        <h2>{program.abstract}</h2>
      </div>
    </div>
  );
};

export default Home3